import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { Trans } from 'react-i18next';

const AboutSection = () => (
  <Container sx={{ py: 8 }}>
    <Typography variant="h4" align="center" gutterBottom>
      <Trans i18nKey="about.title">¿Quiénes Somos?</Trans>
    </Typography>

    <Grid2 container spacing={4}>
      <Grid2 size={{ xs: 12, md: 12 }}>
        <Box sx={{ position: 'relative', borderRadius: 8, overflow: 'hidden' }}>
          <img
            src="/hwamain.jpg"
            alt="Nosotros"
            style={{ width: '100%', display: 'block' }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '50%',
              background: 'linear-gradient(to top, #31174b, transparent)'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              left: 0,
              width: '100%',
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold'
            }}
          >
            <Typography m={2} fontWeight="bold">
              <Trans i18nKey="about.mainCaption">
                Porque somos del mundo y nos está esperando
              </Trans>
            </Typography>
          </Box>
        </Box>
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          <Trans i18nKey="about.mainText">
            Porque creemos que el mundo está hecho para descubrirlo. Porque sabemos que todos nos merecemos viajar. Porque el tiempo y la distancia cada vez nos ceden más oportunidades para salir a explorar.
          </Trans>
        </Typography>
      </Grid2>
      {/* Primer bloque de imagen/texto */}
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Box sx={{ position: 'relative', borderRadius: 8, overflow: 'hidden' }}>
          <img
            src="/hwa1.webp"
            alt="Nosotros 1"
            style={{ width: '100%', display: 'block' }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '50%',
              background: 'linear-gradient(to top, #31174b, transparent)'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              left: 0,
              width: '100%',
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold'
            }}
          >
            <Typography m={2} fontWeight="bold">
              <Trans i18nKey="about.caption1">
                Porque somos del mundo y nos está esperando
              </Trans>
            </Typography>
          </Box>
        </Box>
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          <Trans i18nKey="about.text1">
            Porque creemos que el mundo está hecho para descubrirlo. Porque sabemos que todos nos merecemos viajar. Porque el tiempo y la distancia cada vez nos ceden más oportunidades para salir a explorar.
          </Trans>
        </Typography>
      </Grid2>

      {/* Segundo bloque de imagen/texto */}
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Box sx={{ position: 'relative', borderRadius: 8, overflow: 'hidden' }}>
          <img
            src="/hwa2.webp"
            alt="Nosotros 2"
            style={{ width: '100%', display: 'block' }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '50%',
              background: 'linear-gradient(to top, #31174b, transparent)'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              left: 0,
              width: '100%',
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold'
            }}
          >
            <Typography m={2} fontWeight="bold">
              <Trans i18nKey="about.caption2">
                El mundo es un Globo y para conocerlo, hay que animarse a volar.
              </Trans>
            </Typography>
          </Box>
        </Box>
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          <Trans i18nKey="about.text2">
            Creemos que todos tenemos ganas de viajar, porque es durante un viaje cuando más nos encontramos con nosotros mismos. Aún cuando elijamos diferentes destinos, para todos será igual la plenitud de viajar.
          </Trans>
        </Typography>
      </Grid2>

      {/* Tercer bloque de imagen/texto */}
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Box sx={{ position: 'relative', borderRadius: 8, overflow: 'hidden' }}>
          <img
            src="/hwa3.webp"
            alt="Nosotros 3"
            style={{ width: '100%', display: 'block' }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '50%',
              background: 'linear-gradient(to top, #31174b, transparent)'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              left: 0,
              width: '100%',
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold'
            }}
          >
            <Typography m={2} fontWeight="bold">
              <Trans i18nKey="about.caption3">
                Existen tantas formas de viajar como personas hay en el mundo.
              </Trans>
            </Typography>
          </Box>
        </Box>
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          <Trans i18nKey="about.text3">
            El mundo es como una gran pintura, bañado de distintos colores. Nuestro objetivo es agrupar esos colores bajo una misma bandera y que el viaje nos muestre la diversidad que hay: gente, historias, culturas, experiencias, paisajes y sabores.
          </Trans>
        </Typography>
      </Grid2>
    </Grid2>
  </Container>
);

export default AboutSection;
